/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = IssueMaterialItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class IssueMaterialItemsEditor extends _Ext.GridEditorBase<IssueMaterialItemsRow> {



        protected getColumnsKey() { return "Production.IssueMaterialItems"; }
        protected getDialogType() { return IssueMaterialItemsDialog; }
        protected getLocalTextPrefix() { return IssueMaterialItemsRow.localTextPrefix; }
        protected form: IssueMaterialItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public DeptId: number;
        public Line_No: number;
        public BagNo: string;
        public karatid: number;
        public producttypeid: number;
        public metalcolorid: number;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as IssueMaterialDetailsDialog).CalculateTotals();
                }
            });
            this.slickGrid.onRender.subscribe(() => {
                // call of the function that will bind the editors with the fields (<input>) of the html page
                this.SetInlineLookupEditor();
            });
        }

        private Master;
        //public setEditValue(source: DismantlingRow, property) {
        //    super.setOwnerEntity(source);
        //    this.Master = source;
        //    super.setEditValue(source, property);
        //}
        // #region Column Add -Remove
        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }
        protected getColumns() {

            var columns = super.getColumns();

            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;

            //let ParentMetalColumn = Q.first(columns, x => x.field == fld.ParentMetalId);

            //ParentMetalColumn.format = ctx => {
            //    if (ctx.item.ItemTypeId == "104") {
            //        this.metalcolorid = parseInt(ctx.item.MetalColorId);
            //        this.karatid = parseInt(ctx.item.KaratId);
            //        this.producttypeid = parseInt(ctx.item.ProductTypeId);
            //        return this.selectFormatter(ctx, fld.ParentMetalId, Q.getLookup("AllProducts"), this);
            //    }
            //}
            var ParentMetalColumn = Q.first(columns, x => x.field === fld.ParentMetalId);
            ParentMetalColumn.referencedFields = [fld.ParentMetalId];
            ParentMetalColumn.format = ctx => {

                if (ctx.item.ItemTypeId == "104") {
                    var width = (ctx.column.width) as number - 10;
                    return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="ParentMetalId' + ctx.row + '" title="Parent Metal" />';
                }
            };

            var StoneSettings = Q.first(columns, x => x.field === fld.SettingId);
            StoneSettings.referencedFields = [fld.SettingId];
            StoneSettings.format = ctx => {

                if (ctx.item.ItemTypeId == "105") {
                    var width = (ctx.column.width) as number - 10;
                    return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="SettingId' + ctx.row + '" title="Setting" />';
                }
            };

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion




        

        // **** Onclick Event ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;
            this.slickGrid.setSelectedRows([row]);

            var item = this.itemAt(row);

            //To Set Master Product Image
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    //if ( == 0) {
                    //    Q.alert("Voucher is ReadOnly can not Delete!!")
                    //}
                    //else {
                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {

                        var id = this.id(item);/*
                            var refid = Stock.StockItemRow.getLookup().items.filter(x => x.RefTransItemId == item.TransItemId && x.RefVoucherId == item.VoucherTypeId && x.RefTransId == item.TransId)[0];
                            if (refid != null) {
                                if (refid.PartyId != null || refid.PartyId > 0) {
                                    Q.alert("This Item has been used in transactions Cannot Delete!");
                                    return;
                                }
                            } else {

                              //  this.TotalItems = this.view.getItems().length - 1;
                            */    this.view.deleteItem(id);
                    }
                    );

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }


        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Pieces) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            var olddata: Stock.StockItemRow;
            Stock.StockItemService.GetProductDetails({ ProductId: item.ProductId, AttributeId: item.AttributeId, LotNo: item.LotNo },
                response => olddata = response.Entity,
                { async: false }
            );
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (olddata.Pieces >= value)
                    item[field] = value;
            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    if (olddata.Weight >= value) {
                        item[field] = value;
                        item.NetWeight = value;
                    }
                }
            }

            // *** Set Department ***
            if (field === fld.ParentMetalId && value > 0) {
                item[field] = value;
            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as IssueMaterialDetailsDialog).CalculateTotals();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }

        // **** for Dropdown in Gird ****
        selectFormatter(ctx: Slick.FormatterContext, idField: string, lookup: Q.Lookup<any>, editor: any) {
            var klass = 'edit';
            var item = ctx.item
            var id = editor.id(item);
            var pending = editor.pendingChanges[id]
            var column = ctx.column as Slick.Column;

            var lineno = parseInt((this.parentDialog as IssueMaterialDetailsDialog).form.Line_No.value);
            let newitems;

            IssueMaterialItemsService.ParentMetalList({
                MetalColorId: this.metalcolorid, KaratId: this.karatid, ProductTypeId: this.producttypeid, Line_No: lineno
            }
                , response => { newitems = response.Entities }, { async: false });
            lookup.items = newitems;//lookup.items.filter(x => x.ProductTypeId == this.producttypeid && x.KaratId == this.karatid && x.MetalColorId == this.metalcolorid);
            if (pending && pending[idField] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValues(item, idField, editor);
            var markup = "<select class='" + klass +
                "' data-field='" + idField +
                "' style='width: 100%; max-width: 100%'>";
            for (var c of lookup.items) {
                let id = c[lookup.idField];
                markup += "<option value='" + Q.attrEncode(id) + "'"
                if (id == value) {
                    markup += " selected";
                }
                markup += ">" + Q.htmlEncode(c[lookup.textField]) + "</option>";
            }
            return markup + "</select>";
        }
        getEffectiveValues(item, field: any, editor: any): any {
            var id = editor.id(item);
            var pending = editor.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }
        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        //#region  ItemGrid Inline Editor
        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    if (Items[parseInt(Item)].ItemTypeId ==104)
                        this.ParentMetalLookup(Item, Items);

                    if (Items[parseInt(Item)].ItemTypeId == 105)
                        this.SettingLookup(Item, Items);
                }
        }

        private ParentMetalLookup(RowIndex: string, Items: IssueMaterialItemsRow[]) {

            var select = $("#ParentMetalId" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {

                //let opt: Serenity.LookupEditorOptions = {
                //    lookupKey: IssueMaterialItemsRow.lookupKey
                //};
                let newitems: IssueMaterialItemsRow[];
                var value = Items[parseInt(RowIndex)];
                IssueMaterialItemsService.ParentMetalList({
                    MetalColorId: value.MetalColorId, KaratId: value.KaratId, ProductTypeId: value.ProductTypeId, Line_No: value.Line_No
                }
                    , response => {
                        newitems = response.Entities
                    }, { async: false });
                var parentitems = [];

                for (var i = 0; i < newitems.length; i++) {
                    var item: Select2Item = { id: newitems[i].ProductId.toString(), text: newitems[i].ProductCode, source: newitems[i] }
                    parentitems.push(item);

                }
                var Editor = new _Ext.EmptyLookupEditor($("#ParentMetalId" + RowIndex));
                Editor.setSelect2Items(parentitems);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }
                Editor.value = Q.toId(Items[RowIndex].ProductId);
                Editor.changeSelect2(e => {
                    Items[RowIndex].ParentMetalId = Q.toId(Editor.value);
                    Items[RowIndex].ParentAttributeId = Editor.items.filter(x => x.id == Editor.value)[0].source.AttributeId;
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeClass('readonly');
                }
            }
        }

        private SettingLookup(RowIndex: string, Items: IssueMaterialItemsRow[]) {

            var select = $("#SettingId" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {

                let attributes: OMS.AttributeMasterRow[];
                var value = Items[parseInt(RowIndex)];
                OMS.AttributeMasterService.GetAttributesByType({
                    AttributeTypeId: 22
                }
                    , response => {
                        attributes = response.Entities
                    }, { async: false });
                var setttings = [];

                for (var i = 0; i < attributes.length; i++) {
                    var item: Select2Item = { id: attributes[i].AttributeId.toString(), text: attributes[i].AttributeCode, source: attributes[i] }
                    setttings.push(item);

                }
                var Editor = new _Ext.EmptyLookupEditor($("#SettingId" + RowIndex));
                Editor.setSelect2Items(setttings);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }
                Editor.value = Q.toId(Items[RowIndex].ProductId);
                Editor.changeSelect2(e => {
                    Items[RowIndex].SettingId = Q.toId(Editor.value);
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeClass('readonly');
                }
            }
        }

        //#endregion

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            buttons.push({
                title: "Select Materials",
                cssClass: "order-button",
                hotkey: "alt+p",
                hint: 'alt+p',
                onClick: () => {
                    var self = this;

                    var bagno = (this.parentDialog as IssueMaterialDetailsDialog).form.BagNo.value;
                    if (bagno == "" || bagno == undefined) {
                        q.Alert("View Mode", "Work Order needs to be selected", 2000, false);
                        return;
                    }
                    var grid = Common.WorkOrderStockSelectGrid;
                    var bagno = (self.parentDialog as IssueMaterialDetailsDialog).form.BagNo.value;

                    var filters: _Ext.SelectGridFilters = {
                        BagNo: bagno,
                        FilterItems: 4
                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters, Width: 800, height: 500
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId && n.AttributeId == t.AttributeId) });

                        //let selectedItems2 = selectedItems;
                        var self = this;
                        var details = [];

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Stock.StockItemRow) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            let newitems;

                            var lineno = parseInt((self.parentDialog as IssueMaterialDetailsDialog).form.Line_No.value);
                            var stonesetting = 0;
                            var settingname = "";
                            var orderpieces = 0;
                            var orderweight = 0;
                            if (value.ItemTypeId == 105) {
                                var OrderItem = (self.parentDialog as IssueMaterialDetailsDialog).OrderItem;
                                var bomDetails = OrderItem.BOMDetails;
                                for (var i = 0; i < bomDetails.length; i++) {
                                    var bom = bomDetails[i];
                                    if (value.ItemTypeId == bom.ItemTypeId && value.ShapeId == bom.ShapeId &&
                                        value.StoneSizeId == bom.StoneSizeId && value.SieveId == bom.SieveId) {
                                        stonesetting = bom.SettingId;
                                        orderpieces = bom.Pieces;
                                        orderweight = bom.Weight;
                                        settingname = bom.SettingName;
                                    }
                                }
                            }
                            this.metalcolorid = value.MetalColorId;
                            this.karatid = value.KaratId;
                            this.producttypeid = value.ProductTypeId;
                            this.LineNo = lineno;
                            var bagno = (self.parentDialog as IssueMaterialDetailsDialog).form.BagNo.value;
                            IssueMaterialItemsService.ParentMetalList({
                                MetalColorId: value.MetalColorId, KaratId: value.KaratId, ProductTypeId: value.ProductTypeId, Line_No: self.Line_No, BagNo: bagno
                            }, response => { newitems = response.Entities }, { async: false });
                            var item: IssueMaterialItemsRow = {
                                ProductId: PrdId,
                                DepartmentId: self.DeptId,
                                ProductCode: value.ProductCode,
                                StockDepartmentId: value.DepartmentId,
                                ItemTypeId: value.ItemTypeId,
                                AttributeId: AtbId,
                                OldLineNo: value.Line_No,
                                Line_No: self.Line_No,
                                SKU: value.SKU,
                                HSN: value.HSN,
                                CertificateNo: value.CertificateNo,
                                BagNo: self.BagNo,
                                OldBagNo: value.BagNo,
                                CalcOnId: value.CalcOnId,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                NetWeight: 0,
                                RefTransId: value.TransId,
                                Purity: value.Purity,
                                PureWeight: value.PureWeight,
                                RefTransItemId: value.TransItemId == null ? 0 : value.TransItemId,
                                RefVoucherId: value.VoucherTypeId == null ? 0 : value.VoucherTypeId,
                                Attribute: value.Attribute,
                                KaratId: value.KaratId,
                                MetalColorId: value.MetalColorId,
                                ProductTypeId: value.ProductTypeId,
                                ParentMetalId: 0,// value.ItemTypeId == 104 ? newitems[0].ProductId : 0,
                                ParentAttributeId: 0,
                                LotNo: value.LotNo,
                                Lab: value.Lab,
                                SettingId: stonesetting,
                                SettingName: settingname,
                                OrderPieces: orderpieces,
                                OrderWeight: orderweight
                            };

                            details.push(item);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion


                    }


                    pickerDialog.dialogOpen();
                }
            });

            
            return buttons;
        }
        // #endregion
    }
}